export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: false,
}
export const options = {
  vueI18n: {},
  vueI18nLoader: false,
  locales: [{"name":"Português - Brasil","code":"pt-br","iso":"pt-br","file":"pt-br.js"},{"name":"English","code":"en","iso":"en","file":"en.js"},{"name":"Español","code":"es","iso":"es","file":"es.js"},{"name":"Français","code":"fr","iso":"fr","file":"fr.js"},{"name":"Italiano","code":"it","iso":"it","file":"it.js"},{"name":"日本語","code":"ja","iso":"ja","file":"ja.js"}],
  defaultLocale: "pt-br",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix",
  lazy: true,
  langDir: "i18n/",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":true,"cookieAge":365,"cookieCrossOrigin":false,"cookieDomain":".hotmart.com","cookieKey":"hmLangCookie","cookieSecure":false,"fallbackLocale":"","redirectOn":"root","useCookie":true},
  differentDomains: false,
  baseUrl: "https://hotmart.com",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: false,
  pages: {"index":{"pt-br":"/legal","en":"/legal","es":"/legal","fr":"/legal","it":"/legal","ja":"/legal"},"cookies-policy":{"pt-br":"/legal/politica-de-cookies","en":"/legal/cookies-policy","es":"/legal/politica-de-cookies","fr":"/legal/politique-de-cookies","it":false,"ja":false},"cybersecurity-policy":{"pt-br":"/legal/politica-de-seguranca-cibernetica","en":"/legal/cybersecurity-policy","es":"/legal/politica-de-seguridad","fr":"/legal/politique-de-securite","it":false,"ja":false},"data-privacy-policy":{"pt-br":"/legal/privacidade-de-dados","en":"/legal/data-privacy-policy","es":"/legal/privacidad-de-datos","fr":"/legal/politique-de-confidentialite","it":"/legal/politica-sulla-privacy","ja":"/legal/%E3%83%97%E3%83%A9%E3%82%A4%E3%83%90%E3%82%B7%E3%83%BC%E3%83%9D%E3%83%AA%E3%82%B7%E3%83%BC"},"glossary":{"pt-br":"/legal/glossario","en":"/legal/glossary","es":"/legal/glosario","fr":"/legal/glossaire","it":"/legal/glossario","ja":"/legal/%E3%81%AE%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84%E3%81%AE%E7%94%A8%E8%AA%9E%E9%9B%86"},"payments-policy":{"pt-br":"/legal/politicas-de-pagamento","en":"/legal/payments-policy","es":"/legal/politica-de-pago","fr":"/legal/politique-de-paiements","it":"/legal/politica-di-pagamento","ja":"/legal/%E4%B8%80%E8%88%AC%E6%94%AF%E6%89%95%E8%A6%8F%E7%B4%84"},"purchase-terms":{"pt-br":"/legal/termos-de-compra","en":"/legal/purchase-terms","es":"/legal/plazo-de-compra","fr":"/legal/conditions-generales-dachat","it":"/legal/termini-generali-di-acquisto","ja":"/legal/%E8%B3%BC%E5%85%A5%E8%A6%8F%E7%B4%84"},"responsible-use-policy":{"pt-br":"/legal/politicas-de-uso","en":"/legal/responsible-use-policy","es":"/legal/politicas-de-uso","fr":"/legal/politique-generale-dutilisation-responsable","it":"/legal/politica-generale-di-utilizzo-responsabile","ja":"/legal/%E3%81%AE%E8%B2%AC%E4%BB%BB%E3%81%82%E3%82%8B%E4%BD%BF%E7%94%A8%E3%81%AE%E4%B8%80%E8%88%AC%E3%83%9D%E3%83%AA%E3%82%B7%E3%83%BC"},"terms-of-use":{"pt-br":"/legal/termos-de-uso","en":"/legal/terms-of-use","es":"/legal/terminos-de-uso","fr":"/legal/conditions-generales-dutilisation","it":"/legal/termini-generali-di-utilizzo","ja":"/legal/%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84"},"co-creation-terms-of-use":{"pt-br":"/legal/termos-de-uso-da-coproducao","en":"/legal/co-creation-terms-of-use","es":"/legal/terminos-de-uso-de-la-coproduccion","fr":"/legal/conditions-dutilisation-de-la-coproduction","it":"/legal/termini-di-utilizzo-della-coproduzione","ja":"/legal/%E3%82%B3%E3%83%BB%E3%83%97%E3%83%AD%E3%83%80%E3%82%AF%E3%82%B7%E3%83%A7%E3%83%B3%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84"},"whatsapp-business":{"pt-br":"/legal/whatsapp-business","en":"/legal/whatsapp-business","es":"/legal/whatsapp-business","fr":false,"it":false,"ja":false},"privacy-policy":{"pt-br":"/legal/aviso-de-privacidade","en":"/legal/privacy-notice","es":"/legal/aviso-de-privacidad","fr":false,"it":false,"ja":false},"hotmart-card-policies":{"pt-br":"/legal/politicas-do-cartao-hotmart-para-o-brasil","en":"/legal/hotmart-card-policies","es":"/legal/politicas-de-tarjetas-hotmart","fr":false,"it":false,"ja":false},"data-processing-agreement/creators/index":{"pt-br":"/legal/termo-de-tratamento-de-dados-pessoais-creators","en":"/legal/data-processing-agreement","es":"/legal/termino-de-tratamiento-de-datos-personales-creadores","fr":false,"it":false,"ja":false},"data-processing-agreement/suppliers/index":{"pt-br":"/legal/acordo-de-tratamento-de-dados-pessoais-fornecedor","en":"/legal/data-processing-agreement-suppliers","es":"/legal/acuerdo-de-tratamiento-de-datos-personales-proveedor","fr":false,"it":false,"ja":false},"data-processing-agreement/suppliers/appendix-i":{"pt-br":"/legal/acordo-de-tratamento-de-dados-pessoais-fornecedor-anexo-i","en":"/legal/data-processing-agreement-suppliers-appendix-i","es":"/legal/acuerdo-de-tratamiento-de-datos-personales-proveedor-apendice-i","fr":false,"it":false,"ja":false},"data-processing-agreement/suppliers/appendix-ii":{"pt-br":"/legal/acordo-de-tratamento-de-dados-pessoais-fornecedor-anexo-ii","en":"/legal/data-processing-agreement-suppliers-appendix-ii","es":"/legal/acuerdo-de-tratamiento-de-datos-personales-proveedor-apendice-ii","fr":false,"it":false,"ja":false},"data-processing-agreement/suppliers/appendix-iii":{"pt-br":"/legal/acordo-de-tratamento-de-dados-pessoais-fornecedor-anexo-iii","en":"/legal/data-processing-agreement-suppliers-appendix-iii","es":"/legal/acuerdo-de-tratamiento-de-datos-personales-proveedor-apendice-iii","fr":false,"it":false,"ja":false},"data-processing-agreement/suppliers/appendix-iv":{"pt-br":"/legal/acordo-de-tratamento-de-dados-pessoais-fornecedor-anexo-iv","en":"/legal/data-processing-agreement-suppliers-appendix-iv","es":"/legal/acuerdo-de-tratamiento-de-datos-personales-proveedor-apendice-iv","fr":false,"it":false,"ja":false}},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  fallbackLocale: "en",
  normalizedLocales: [{"name":"Português - Brasil","code":"pt-br","iso":"pt-br","file":"pt-br.js"},{"name":"English","code":"en","iso":"en","file":"en.js"},{"name":"Español","code":"es","iso":"es","file":"es.js"},{"name":"Français","code":"fr","iso":"fr","file":"fr.js"},{"name":"Italiano","code":"it","iso":"it","file":"it.js"},{"name":"日本語","code":"ja","iso":"ja","file":"ja.js"}],
  localeCodes: ["pt-br","en","es","fr","it","ja"],
  additionalMessages: [],
}
export const localeFiles = {
  0: "{",
  1: "\"",
  2: "p",
  3: "t",
  4: "-",
  5: "b",
  6: "r",
  7: ".",
  8: "j",
  9: "s",
  10: "\"",
  11: ":",
  12: "\"",
  13: ".",
  14: ".",
  15: "/",
  16: "i",
  17: "1",
  18: "8",
  19: "n",
  20: "/",
  21: "p",
  22: "t",
  23: "-",
  24: "b",
  25: "r",
  26: ".",
  27: "j",
  28: "s",
  29: "\"",
  30: ",",
  31: "\"",
  32: "e",
  33: "n",
  34: ".",
  35: "j",
  36: "s",
  37: "\"",
  38: ":",
  39: "\"",
  40: ".",
  41: ".",
  42: "/",
  43: "i",
  44: "1",
  45: "8",
  46: "n",
  47: "/",
  48: "e",
  49: "n",
  50: ".",
  51: "j",
  52: "s",
  53: "\"",
  54: ",",
  55: "\"",
  56: "e",
  57: "s",
  58: ".",
  59: "j",
  60: "s",
  61: "\"",
  62: ":",
  63: "\"",
  64: ".",
  65: ".",
  66: "/",
  67: "i",
  68: "1",
  69: "8",
  70: "n",
  71: "/",
  72: "e",
  73: "s",
  74: ".",
  75: "j",
  76: "s",
  77: "\"",
  78: ",",
  79: "\"",
  80: "f",
  81: "r",
  82: ".",
  83: "j",
  84: "s",
  85: "\"",
  86: ":",
  87: "\"",
  88: ".",
  89: ".",
  90: "/",
  91: "i",
  92: "1",
  93: "8",
  94: "n",
  95: "/",
  96: "f",
  97: "r",
  98: ".",
  99: "j",
  100: "s",
  101: "\"",
  102: ",",
  103: "\"",
  104: "i",
  105: "t",
  106: ".",
  107: "j",
  108: "s",
  109: "\"",
  110: ":",
  111: "\"",
  112: ".",
  113: ".",
  114: "/",
  115: "i",
  116: "1",
  117: "8",
  118: "n",
  119: "/",
  120: "i",
  121: "t",
  122: ".",
  123: "j",
  124: "s",
  125: "\"",
  126: ",",
  127: "\"",
  128: "j",
  129: "a",
  130: ".",
  131: "j",
  132: "s",
  133: "\"",
  134: ":",
  135: "\"",
  136: ".",
  137: ".",
  138: "/",
  139: "i",
  140: "1",
  141: "8",
  142: "n",
  143: "/",
  144: "j",
  145: "a",
  146: ".",
  147: "j",
  148: "s",
  149: "\"",
  150: "}",
}

export const localeMessages = {
  'pt-br.js': () => import('../../i18n/pt-br.js' /* webpackChunkName: "lang-pt-br.js" */),
  'en.js': () => import('../../i18n/en.js' /* webpackChunkName: "lang-en.js" */),
  'es.js': () => import('../../i18n/es.js' /* webpackChunkName: "lang-es.js" */),
  'fr.js': () => import('../../i18n/fr.js' /* webpackChunkName: "lang-fr.js" */),
  'it.js': () => import('../../i18n/it.js' /* webpackChunkName: "lang-it.js" */),
  'ja.js': () => import('../../i18n/ja.js' /* webpackChunkName: "lang-ja.js" */),
}
